import type { CSSProperties, ReactNode } from "react";
import { Flex as FlexBase, SpaceBase } from "./Space";
import { cx } from "./fieldContext";

export interface SpaceCompactProps {
  block?: boolean;
  direction?: "horizontal" | "vertical";
  size?: "small" | "middle" | "large";
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

/** Verbundene Gruppe (Ersatz für Antd `Space.Compact`): Felder und Knöpfe stoßen ohne Abstand und mit gemeinsamen Ecken an (`controls.css`). */
function SpaceCompact({ block, direction = "horizontal", className, style, children }: SpaceCompactProps) {
  return (
    <div className={cx("ck-space-compact", block && "ck-space-compact-block", direction === "vertical" && "ck-space-compact-vertical", className)} style={style}>
      {children}
    </div>
  );
}

/** `settingsListRole: "group"` lässt die Shared-Liste Kit-`Space`/`Flex` wie die Antd-Vorbilder auflösen. */
export const Space = Object.assign(SpaceBase, { Compact: SpaceCompact, settingsListRole: "group" as const });
export const Flex = Object.assign(FlexBase, { settingsListRole: "group" as const });
